import { render } from "./VideoPlayerYT.vue?vue&type=template&id=07abbf53"
import script from "./VideoPlayerYT.vue?vue&type=script&lang=js"
export * from "./VideoPlayerYT.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__